import { KA_CATEGORY_ORDER } from "./kaConstants";

/**
 * Sorts assessment sections into the canonical display order. Sections whose path isn't in
 * KA_CATEGORY_ORDER keep their API order and go after the known ones, so a newly added section
 * never jumps to the front.
 */
export const sortExamSections = <T extends { path?: string }>(sections: readonly T[]): T[] => {
  const rank = (section: T) => {
    const index = KA_CATEGORY_ORDER.indexOf(section.path ?? "");
    return index === -1 ? KA_CATEGORY_ORDER.length : index;
  };
  return [...sections].sort((a, b) => rank(a) - rank(b));
};
